/**
 * 상품 타입.
 */
export const SHOP_PRODUCT_TYPES = {
  ITEM: 'ITEM',
  ITEM_PACKAGE: 'ITEM_PACKAGE',
  IAB_ITEM: 'IAB_ITEM',
  IAB_GEM: 'IAB_GEM',
  IAB_SUBSCRIPTION: 'IAB_SUBSCRIPTION',
} as const;

export type ShopProductType = (typeof SHOP_PRODUCT_TYPES)[keyof typeof SHOP_PRODUCT_TYPES];

/**
 * 구매 횟수 제한에 도달한 경우 동작 타입.
 */
export const PURCHASE_LIMIT_BEHAVIOR_TYPES = {
  /**
   * 상품을 미노출한다.
   */
  HIDDEN: 'HIDDEN',

  /**
   * 구매 버튼을 비활성화한다.
   */
  DISABLED: 'DISABLED',
} as const;

export type PurchaseLimitBehaviorType =
  (typeof PURCHASE_LIMIT_BEHAVIOR_TYPES)[keyof typeof PURCHASE_LIMIT_BEHAVIOR_TYPES];

/**
 * 상품 기간의 단위.
 */
export const PERIOD_UNIT_TYPES = {
  MINUTES: 'MINUTES',
  HOURS: 'HOURS',
  DAYS: 'DAYS',
  MONTHS: 'MONTHS',
} as const;

export type PeriodUnitType = (typeof PERIOD_UNIT_TYPES)[keyof typeof PERIOD_UNIT_TYPES];

/**
 * 상품 속성을 담고 있는 DTO.
 */
export interface DTOProduct {
  /**
   * 모듈 타입.
   */
  moduleType: string;

  /**
   * 모듈 종료 날짜.
   */
  moduleEndDate?: number;

  /**
   * 상품 이름.
   */
  productName?: string;

  /**
   * 상품 아이콘 URL.
   */
  iconUrl?: string;

  /**
   * 상품 타입.
   */
  productType: ShopProductType;

  /**
   * 상품 ID.
   */
  productId: string;

  /**
   * 할인율.
   */
  discountRate?: string;

  /**
   * 상품 기간.
   */
  period?: number;

  /**
   * 상품 기간의 단위.
   */
  periodUnit?: PeriodUnitType;

  /**
   * 젬 가격.
   */
  gemPrice?: number;

  /**
   * 구매 횟수 제한의 도달 여부.
   */
  purchaseLimitExceeded: boolean;

  /**
   * 구매 횟수 제한에 도달한 경우 동작.
   */
  purchaseLimitBehavior?: PurchaseLimitBehaviorType;

  /**
   * 공통 상품 정보를 제외한 부가 정보.
   */
  content?: Record<string, unknown>;

  /**
   * 뱃지 정보.
   */
  badge?: Record<string, unknown>;

  /**
   * PG 가격 정보.
   */
  pgPrice?: {
    price: number;

    currency: string;
  };
}
